
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/realtime",
      function () {
        return require("private-next-pages/realtime.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/realtime"])
      });
    }
  